/// <reference types="react" /> /// <reference types="react/jsx-runtime" />

import React from 'react';
import { CssBaseline } from '@mui/material';
import { ThemeProviderWithDirection } from './theme';
import { LoginForm as GuardianLoginForm } from './features/guardian/auth/components/LoginForm';
import { LoginForm as AdminLoginForm } from './features/admin/auth/components/LoginForm'; 
import { GuardianLayout } from './features/guardian/layout/GuardianLayout';
import { AdminLayout } from './features/admin/layout/AdminLayout';
import { Dashboard as GuardianDashboard } from './features/guardian/dashboard/Dashboard';
import { Dashboard as AdminDashboard } from './features/admin/dashboard/Dashboard';
import { SchoolsScreen } from './features/admin/schools/components/SchoolsScreen';
import { PackagesScreen } from './features/admin/packages/components/PackagesScreen';
import { GuardiansScreen } from './features/admin/guardians/components/GuardiansScreen';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './i18n';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

function App() {
  const handleGuardianLoginSuccess = () => {
    // The navigation will be handled by the router
    window.location.href = '/guardian/dashboard';
  };

  const handleAdminLoginSuccess = () => {
    // The navigation will be handled by the router
    window.location.href = '/admin/dashboard';
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <ThemeProviderWithDirection>
        <CssBaseline />
        <BrowserRouter>
          <Routes>
            {/* Public routes */}
            <Route path="/guardian/login" element={<GuardianLoginForm onLoginSuccess={handleGuardianLoginSuccess} />} />
            <Route path="/admin/login" element={<AdminLoginForm onLoginSuccess={handleAdminLoginSuccess} />} />
            
            {/* Guardian routes */}
            <Route path="/guardian" element={<GuardianLayout />}>
              <Route path="dashboard" element={<GuardianDashboard />} />
              <Route index element={<Navigate to="dashboard" replace />} />
            </Route>

            {/* Admin routes */}
            <Route path="/admin" element={<AdminLayout />}>
              <Route path="dashboard" element={<AdminDashboard />} />
              <Route path="schools" element={<SchoolsScreen />} />
              <Route path="packages" element={<PackagesScreen />} />
              <Route path="guardians" element={<GuardiansScreen />} />
              <Route index element={<Navigate to="dashboard" replace />} />
            </Route>

            {/* Redirect root to login */}
            <Route path="/" element={<Navigate to="/guardian/login" replace />} />
          </Routes>
        </BrowserRouter>
      </ThemeProviderWithDirection>
    </LocalizationProvider>
  );
}

export default App;
